{
    "contest":{
       "name":"json.contest_top",
       "params":{
          "contest_id":{
             "type":"string",
             "required":true
          }
       },
       
       "authRequire":false,
       "result":{
          
       }
    },
    "actionsLog":{
       "name":"json.actionslog",
       "params":{
          
       },
       
       "authRequire":true
    },
    "apikeyList":{
       "name":"json.api_key_list",
       "params":{
          
       },
       
       "authRequire":true
    },
    "apikeyAdd":{
       "name":"json.add_api_key",
       "params":{
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "apikeyDelete":{
       "name":"json.delete_api_key",
       "params":{
          "apikey":{
             "type":"string",
             "required":true
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "apikeySave":{
       "name":"json.save_api_key",
       "params":{
          "apikey":{
             "type":"string",
             "required":true
          },
          "ip_restriction_enabled":{
             "type":"boolean",
             "required":false
          },
          "trade_enabled":{
             "type":"boolean",
             "required":false
          },
          "withdraw_enabled":{
             "type":"boolean",
             "required":false
          },
          "ip_restriction_list":{
             "type":"string",
             "required":false
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "blotter":{
       "name":"json.blotter",
       "params":{
          "sym":{
             "type":"string",
             "required":false
          }
       },
       
       "authRequire":true
    },
    "deposit":{
       "name":"json.deposit",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          }
       },
       
       "authRequire":true
    },
    "withdraw":{
       "name":"json.place_withdraw",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          },
          "amount":{
             "type":"number",
             "required":true
          },
          "fee":{
             "type":"number",
             "required":true
          },
          "to_addr":{
             "type":"string",
             "required":true
          },
          "to_tag":{
             "type":"string",
             "required":false
          },
          "public_key":{
             "type":"string",
             "required":false
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "addressbookAdd": {
      "name":"json.update_wd_address",
      "params":{
         "blockchain":{
            "type":"string",
            "required":true
         },
         "addr":{
            "type":"string",
            "required":true
         },
         "memo":{
            "type":"string",
            "required":false
         },
         "otp":{
            "type":"otp",
            "required":true
         }
      },
      "authRequire":true,
      "calledByUser":true
    },
    "addressbookRemove": {
      "name":"json.remove_wd_address",
      "params":{
         "blockchain":{
            "type":"string",
            "required":true
         },
         "addr":{
            "type":"string",
            "required":true
         },
         "otp":{
            "type":"otp",
            "required":true
         }
      },
      "authRequire":true,
      "calledByUser":true
    },
    "addressbook": {
      "name":"json.wd_addresses",
      "params":{
      },
      "authRequire":true
    },
    "ewaGet":{
       "name":"json.get_emergency_address",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          }
       },
       
       "authRequire":true,
       "silenced":true
    },
    "ewaSet":{
       "name":"json.set_emergency_address",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          },
          "tag":{
             "type":"string",
             "required":false
          },
          "address":{
             "type":"string",
             "required":true
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "authRequire":true,
       "calledByUser":true
    },
    "getMessages":{
       "name":"json.messages",
       "params":{
          
       },
       "authRequire":true,
       "calledByUser":false
    },
    "loanOrders":{
       "name":"json.loans",
       "params":{
          "sym":{
             "type":"string",
             "required":false
          },
          "history":{
             "type":"integer",
             "required":false
          }
       },
       "authRequire":false,
       "calledByUser":false
    },
    "loanOB":{
       "name":"json.loan_ob",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          }
       },
       "authRequire":false,
       "calledByUser":false
    },
    "loanOBTotal":{
       "name":"json.loan_ob",
       "params":{
          
       },
       "authRequire":false,
       "calledByUser":false
    },
    "loanGet":{
       "name":"json.get_loan",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          },
          "amount":{
             "type":"number",
             "required":true
          },
          "max_daily_percent":{
             "type":"number",
             "required":true
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "authRequire":true,
       "calledByUser":true
    },
    "loanOrderChange":{
       "name":"json.change_loan",
       "params":{
          "loan_id":{
             "type":"integer",
             "required":true
          },
          "max_percent":{
             "type":"number",
             "required":true
          }
       },
       "authRequire":true,
       "calledByUser":true
    },
    "loanGetAvailable":{
       "name":"json.get_loan",
       "params":{
          "max_daily_percent":{
             "type":"integer",
             "required":true
          }
       },
       "authRequire":true,
       "calledByUser":false
    },
    "loanPayBack":{
       "name":"json.pay_back_loan",
       "params":{
          "sym":{
             "type":"string",
             "required":false
          },
          "liq":{
             "type":"string",
             "required":false
          }
       },
       "authRequire":false,
       "calledByUser":true
    },
    "lendingPlace":{
       "name":"json.place_lending",
       "params":{
          "sym":{
             "type":"string",
             "required":true
          },
          "amount":{
             "type":"number",
             "required":true
          },
          "perc":{
             "type":"number",
             "required":true
          }
       },
       "authRequire":true,
       "calledByUser":true
    },
    "lendingCancel":{
       "name":"json.cancel_lending",
       "params":{
          "oid":{
             "type":"integer",
             "required":true
          },
          "cancel_unused":{
             "type":"integer",
             "required":false
          }
       },
       "authRequire":false,
       "calledByUser":true
    },
    "lendingOrders":{
       "name":"json.lending_orders",
       "params":{
          "sym":{
             "type":"string",
             "required":false
          },
          "pn":{
             "type":"integer",
             "required":false
          },
          "history":{
             "type":"integer",
             "required":false
          }
       },
       "authRequire":false,
       "calledByUser":false
    },
    "pwdReset":{
       "name":"json.resetpwd",
       "params":{
          "email":{
             "type":"email",
             "required":true
          },
          "password":{
             "type":"password",
             "required":true
          },
          "repassword":{
             "type":"string",
             "required":true
          },
          "emailcode":{
             "type":"string",
             "required":true
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "calledByUser":true
    },
    "pwdGetEmailCode":{
       "name":"json.init_resetpwd",
       "params":{
          "email":{
             "type":"email",
             "required":true
          }
       },
       "calledByUser":true
    },
    "settingsRead":{
       "name":"json.readsettings",
       "params":{
          "type":{
             "type":"string",
             "required":true
          }
       },
       
       "authRequire":true
    },
    "settingsWrite":{
       "name":"json.writesettings",
       "params":{
          "settings":{
             "type":"string",
             "required":true
          },
          "clear": {
            "type":"string",
            "required":false
         }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "settingsWriteSilence":{
       "name":"json.writesettings",
       "params":{
          "settings":{
             "type":"string",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true,
       "silenced":true
    },
    "orderCreate":{
       "name":"json.place_order",
       "params":{
          "infinity":{
             "type":"boolean",
             "required":false
          },
          "v":{
             "type":"number",
             "required":true
          },
          "r":{
             "type":"number",
             "required":true
          },
          "copied_from_id":{
             "type":"integer",
             "required":false
          },
          "memo":{
             "type":"string",
             "required":false
          },
          "tp_r":{
             "type":"number",
             "required":false
          },
          "sl_trigger":{
             "reference_required":[
                "tp_r",
                "sl_r"
             ],
             "type":"number",
             "required":false
          },
          "sl_r":{
             "reference_required":[
                "tp_r",
                "sl_trigger"
             ],
             "type":"number",
             "required":false
          },
          "slippage_pr":{
             "reference_required":[
                "tp_r",
                "trailing_pr"
             ],
             "type":"number",
             "min":0,
             "required":false
          },
          "trailing_pr":{
             "reference_required":[
                "tp_r",
                "slippage_pr"
             ],
             "min":0,
             "type":"number",
             "required":false
          },
          "pair":{
             "type":"string",
             "required":true
          },
          "ot":{
            "type":"string",
             "values":[
                "l",
                "m"
             ],
             "required":true
          },
          "bs":{
            "type":"string",
             "values":[
                "b",
                "s"
             ],
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "orderEdit":{
       "name":"json.change_order",
       "params":{
          "oid":{
             "type":"integer",
             "required":true
          },
          "amount":{
             "type":"number",
             "required":false
          },
          "rate":{
             "type":"number",
             "required":false
          },
          "memo":{
             "type":"string",
             "required":false
          },
          "tp_r":{
             "type":"number",
             "required":false
          },
          "sl_trigger":{
             "type":"number",
             "required":false
          },
          "sl_r":{
             "type":"number",
             "required":false
          },
          "slippage_pr":{
             "type":"number",
             "required":false
          },
          "trailing_pr":{
             "type":"number",
             "required":false
          },
          "expire_time":{
             "type":"number",
             "required":false
          },
          "remove_sltp":{
            "type":"string",
             "values":[
                "sl",
                "sltp"
             ],
             "required":false
          },
          "close_as_filled":{
             "type":"integer",
             "required":false
          },
          "set_fulfilled":{
             "type":"integer",
             "values":[1],
             "required":false
          },
          "from_history":{
             "type":"integer",
             "values":[1],
             "required":false
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "orderInfo":{
       "name":"json.orderinfo",
       "params":{
          "oid":{
             "type":"integer",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    
    "orderMakePosition": {
      "name":"json.change_order",
      "params":{
         "oid":{
            "type":"integer",
            "required":true
         },
         "close_as_filled":{
            "type":"integer",
            "values":[1],
            "required":true
         }
      },
      "calledByUser":true,
      "authRequire":true
    },
    "orderCloseAsFullfiled": {
      "name":"json.change_order",
      "params":{
         "oid":{
            "type":"integer",
            "required":true
         },
         "set_fulfilled":{
            "type":"integer",
            "values":[1],
            "required":true
         },
         "from_history":{
            "type":"integer",
            "values":[1],
            "required":true
         }
      },
      "calledByUser":true,
      "authRequire":true
    },
    "orderList":{
       "name":"json.orderslist",
       "params":{
          "history":{
            "type":"integer",
             "values":[
                1
             ],
             "required":false
          },
          "order":{
            "type":"integer",
             "values":[
                1
             ],
             "required":false
          },
          "ps":{
             "type":"integer",
             "required":false
          },
          "pn":{
             "type":"integer",
             "required":false
          },
          "begin":{
             "type":"integer",
             "required":false
          },
          "end":{
             "type":"integer",
             "required":false
          }
       },
       
       "authRequire":true
    },
    "orderCancel":{
       "name":"json.cancel_order",
       "params":{
          "oid":{
             "type":"integer",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "orderCancelAll":{
       "name":"json.cancel_orders",
       "params":{
          "bs":{
            "type":"string",
             "values":[
                "b",
                "s",
                "all"
             ],
             "required":false
          },
          "sym":{
            "type":"string",
             "required":false
          },
          "pair":{
            "type":"string",
             "required":false
          }
       },
       
       "authRequire":true
    },
    "withdrawCancel":{
       "name":"json.cancel_withdraw",
       "params":{
          "wd_oid":{
             "type":"integer",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "orderGraphOID":{
       "name":"json.get_visual_link",
       "params":{
          "oid":{
             "type":"integer",
             "required":true
          }
       },
       
       "authRequire":false
    },
    "userinfo":{
       "name":"json.userinfo",
       "params":{},
       "calledByUser":false
    },
    "userinfoUpdate":{
       "name":"json.update_userinfo",
       "params":{
          "remove_agreement":{
             "type":"string",
             "required":false
          },
          "last_message":{
             "type":"integer",
             "required":false
          },
          "agreements":{
             "type":"string",
             "required":false
          },
          "withdrawal_delay":{
             "type":"integer",
             "required":false
          },
          "otp":{
             "type":"otp",
             "required":true
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "currencies":{
       "name":"json.currencies",
       "params":{
          
       },
       "calledByUser":false
    },
    "masterKeyGet":{
       "name":"json.masterkey",
       "params":{
          "otp":{
             "required":true,
             "type":"otp"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "masterKeySet":{
       "name":"json.masterkey",
       "params":{
          "step":{
             "required":true,
             "type":"number",
             "values":[
                2
             ]
          },
          "lastchars":{
             "required":true,
             "type":"string"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "wOTPGet":{
       "name":"json.enable_2fa",
       "params":{
          "otp":{
             "required":true,
             "type":"otp"
          },
          "wotp":{
             "required":true,
             "type":"number",
             "values":[
                1
             ]
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "wOTPSet":{
       "name":"json.enable_2fa",
       "params":{
          "step":{
             "required":true,
             "type":"number",
             "values":[
                2
             ]
          },
          "otp":{
             "required":true,
             "type":"otp"
          },
          "wotp":{
             "required":true,
             "type":"number",
             "values":[
                1
             ]
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "wOTPdisable":{
       "name":"json.disable_2fa",
       "params":{
          "otp":{
             "required":true,
             "type":"otp"
          },
          "wotp":{
             "required":true,
             "type":"number",
             "values":[
                1
             ]
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "otpGet":{
       "name":"json.enable_2fa",
       "params":{
          
       },
       "calledByUser":true,
       "authRequire":true
    },
    "otpSet":{
       "name":"json.enable_2fa",
       "params":{
          "step":{
             "required":true,
             "type":"number",
             "values":[
                2
             ]
          },
          "otp":{
             "required":true,
             "type":"otp"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "otpGetChange":{
       "name":"json.enable_2fa",
       "params":{
          "otp":{
             "required":true,
             "type":"otp"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "signIn":{
       "name":"json.login",
       "params":{
          "email":{
             "required":true,
             "type":"email"
          },
          "password":{
             "required":true,
             "type":"string"
          },
          "otp":{
             "required":false,
             "type":"otp"
          }
       },
       "calledByUser":true
    },
    "signUp":{
       "name":"json.join",
       "params":{
          "email":{
             "required":true,
             "type":"email"
          },
          "password":{
             "required":true,
             "type":"string"
          },
          "repassword":{
            "type":"string",
             "required":true,
             "equal2param":"password"
          },
          "promo":{
             "required":false,
             "type":"string"
          }
       },
       "calledByUser":true
    },
    "singUpConfirm":{
       "name":"json.confirm_email",
       "params":{
          "confirmation_code":{
             "required":true,
             "type":"string"
          }
       },
       "calledByUser":true
    },
    "logout":{
       "name":"json.logout",
       "params":{
          
       },
       "calledByUser":true,
       "authRequire":true
    },
    "logoutAll":{
       "name":"json.logout_all",
       "params":{
          
       },
       "calledByUser":true,
       "authRequire":true
    },
    "tradeLog":{
       "name":"json.tradelog",
       "params":{
          
       },
       
       "authRequire":true
    },
    "fees":{
       "name":"json.fees",
       "params":{
          
       },
       "calledByUser":false
    },
    "terminateAccount":{
       "name":"json.terminate_account",
       "params":{
          "masterkey":{
             "required":true,
             "type":"string"
          },
          "ewa_set": {
             "required": false,
             "type": "object"
          }
       },
       "calledByUser":true
    },
    "transactionsWithdrawal":{
       "name":"json.withdraw_orders",
       "params":{
         "sym":{
            "required":false,
            "type":"string"
         },
         "state":{
            "required":false,
            "type":"string"
         },         
         "pn":{
            "required":false,
            "type":"integer"
         },         
         "begin":{
            "required":false,
            "type":"integer"
         },         
         "end":{
            "required":false,
            "type":"integer"
         },         
         "ps":{
            "required":false,
            "type":"integer"
         }
       },
       
       "authRequire":true
    },
    "transactionsIncoming":{
       "name":"json.incoming_transactions",
       "params":{
         "sym":{
            "required":false,
            "type":"string"
         },
         "state":{
            "required":false,
            "type":"string"
         },         
         "pn":{
            "required":false,
            "type":"integer"
         },         
         "begin":{
            "required":false,
            "type":"integer"
         },         
         "end":{
            "required":false,
            "type":"integer"
         },         
         "ps":{
            "required":false,
            "type":"integer"
         }
         
       },
       
       "authRequire":true
    },
    "telegramRemove":{
       "name":"json.telebot_remove",
       "params":{
          "chat_id":{
             "required":false,
             "type":"string"
          },
          "remove_all":{
             "required":false,
             "type":"boolean"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "telegramGetPin":{
       "name":"json.telebot_pin",
       "params":{
          "otp":{
             "required":true,
             "type":"otp"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "telegramWriteSettings":{
       "name":"json.telebot_writesettings",
       "params":{
          "setmain":{
             "required":false,
             "type":"string"
          },
          "login":{
             "required":false,
             "type":"boolean"
          },
          "securitypack":{
             "required":false,
             "type":"boolean"
          },
          "incomingtransaction":{
             "required":false,
             "type":"boolean"
          },
          "withdrawaltransaction":{
             "required":false,
             "type":"boolean"
          },
          "orderactions":{
             "required":false,
             "type":"boolean"
          },
          "trades":{
             "required":false,
             "type":"boolean"
          },
          "orderfulfilment":{
             "required":false,
             "type":"boolean"
          },
          "dailyreport":{
             "required":false,
             "type":"boolean"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaDashboard":{
       "name":"json.pmadashboard",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          }
       },
       "calledByUser":false
    },
    "pmaTrades":{
       "name":"json.pmatrades",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          }
       },
       "calledByUser":false
    },
    "pmaInfo":{
       "name":"json.pmainfo",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          }
       },
       "calledByUser":false
    },
    "pmaOwn":{
       "name":"json.managed_pma",
       "params":{
          
       },
       
       "authRequire":true
    },
    "pmaList":{
       "name":"json.pmalist",
       "params":{
          
       },
       "calledByUser":false
    },
    "pmaDepositList":{
       "name":"json.deposits_pma",
       "params":{
         "pmaid":{
            "required": false,
            "type": "integer"
         },
         "history":{
            "required": false,
            "type": "integer"
         }
       },
       
       "authRequire":true
    },
    "pmaDepositClose":{
       "name":"json.closedeposit_pma",
       "params":{
          "dep_id":{
             "required":true,
             "type":"integer"
          },
          "otp":{
             "required":true,
             "type":"string"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaDepositCloseAll":{
       "name":"json.closealldeposits_pma",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          },
          "otp":{
             "required":true,
             "type":"string"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaDepositOpen":{
       "name":"json.opendeposit_pma",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          },
          "volume":{
             "required":true,
             "type":"number"
          },
          "sym2":{
             "required": false,
             "type":"string"
          },
          "sym2_amount":{
             "required": false,
             "type":"number"
          },
          "otp":{
             "required":true,
             "type":"string"
          },
          "capitalization":{
             "required":false,
             "type":"boolean"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaOpenInfo":{
       "name":"json.new_pma",
       "params":{
          
       },
       "calledByUser":false
    },
    "pmaChart":{
       "name":"json.pmachart",
       "params":{
         "pmaid":{
            "required":true,
            "type":"integer"
         }
       },
       "calledByUser":false
    },
    "pmaOpen":{
       "name":"json.open_pma",
       "params":{
          "basesym":{
             "required":true,
             "type":"string"
          },
          "name":{
             "required":true,
             "type":"string"
          },
          "description":{
             "required":false,
             "type":"string"
          },
          "reward":{
             "required":true,
             "type":"string"
          },
          "maxdd":{
             "required":true,
             "type":"string"
          },
          "mindeposit":{
             "required":false,
             "type":"string"
          },
          "lockup":{
             "required":true,
             "type":"string"
          },
          "cycle":{
             "required":true,
             "type":"string"
          },
          "referral":{
             "required":true,
             "type":"string"
          },
          "cross":{
             "required":false,
             "type":"string"
          },
          "stoploss":{
             "required":true,
             "type":"string"
          },
          "maxspread":{
             "required":true,
             "type":"string"
          },
          "guestlevel":{
             "required":true,
             "type":"string"
          },
          "userlevel":{
             "required":true,
             "type":"string"
          },
          "managersshare":{
             "required":true,
             "type":"string"
          },
          "symlimits":{
             "required":false,
             "type":"string"
          },
          "feesym":{
             "required":true,
             "type":"string"
          },
          "feevol":{
             "required":true,
             "type":"string"
          },
          "otp":{
             "required":true,
             "type":"string"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaEdit":{
       "name":"json.edit_pma",
       "params":{
          "basesym":{
             "required":false,
             "type":"string"
          },
          "name":{
             "required":false,
             "type":"string"
          },
          "description":{
             "required":false,
             "type":"string"
          },
          "reward":{
             "required":false,
             "type":"string"
          },
          "maxdd":{
             "required":false,
             "type":"string"
          },
          "mindeposit":{
             "required":false,
             "type":"string"
          },
          "lockup":{
             "required":false,
             "type":"string"
          },
          "cycle":{
             "required":false,
             "type":"string"
          },
          "referral":{
             "required":false,
             "type":"string"
          },
          "cross":{
             "required":false,
             "type":"string"
          },
          "stoploss":{
             "required":false,
             "type":"string"
          },
          "maxspread":{
             "required":false,
             "type":"string"
          },
          "guestlevel":{
             "required":false,
             "type":"string"
          },
          "userlevel":{
             "required":false,
             "type":"string"
          },
          "managersshare":{
             "required":false,
             "type":"string"
          },
          "otp":{
             "required":true,
             "type":"string"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaSwitch":{
       "name":"json.switch_pma",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaClearing":{
       "name":"json.pma_clearing",
       "params":{
          
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaClose":{
       "name":"json.pma_close",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          },
          "otp":{
             "required":true,
             "type":"otp"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "pmaCloseCancel":{
       "name":"json.pma_closecancel",
       "params":{
          "pmaid":{
             "required":true,
             "type":"integer"
          },
          "otp":{
             "required":true,
             "type":"otp"
          }
       },
       "calledByUser":true,
       "authRequire":true
    },
    "browserCheck":{
       "name":"json.check_browser",
       "params":{
          
       },
       
       "authRequire":false
    },
    
    "convertDust": {
        "name": "json.convert_dust",
        "params": {
            "sym": {
                "type": "string", 
                "required": true
            }
        },
        "calledByUser": true,
        "authRequire": true
    },
    "getWithdrawComission": {
        "name": "json.get_wdcom_for_address",
        "params": {
            "addr": {
                "type": "string", 
                "required": true
            },
            "sym": {
                "type": "string", 
                "required": true
            }
        },
        "authRequire": true
    },
    "advcashDeposit": {
        "name": "json.advcash_make_deposit",
        "params": {
            "deposit_method": {
                "type": "string", 
                "required": true
            },
            "fiat": {
                "type": "string", 
                "required": true
            },
            "fiat_amount": {
                "type": "number", 
                "required": false
            },
            "amount": {
                "type": "number", 
                "required": false
            },
            "sym": {
                "type": "string", 
                "required": true
            }
        },
        "authRequire": true
    },
    "advcashDepositList": {
        "name": "json.adc_deposits",
        "params": {

        },
        "authRequire": true
    },
    "resetDepositWallet": {
        "name": "json.reset_deposit_wallets",
        "params": {
            "sym": {
               "type": "string", 
               "required": true
            },
            "otp": {
               "type": "otp", 
               "required": true
            }
        },
        "authRequire": true
    },
    "changeLang": {
        "name": "json.change_lang",
        "params": {
            "lang": {
               "type": "string", 
               "required": true
            }
        },
        "authRequire": true
    },
    "alertslist": {
        "name": "json.alertslist",
        "params": {
            "pair": {
               "type": "string", 
               "required": false
            },
            "coin": {
               "type": "string", 
               "required": false
            }
        },
        "authRequire": true
    },
    "orderinfo": {
        "name": "json.orderinfo",
        "params": {
            "oid": {
               "type": "number", 
               "required": true
            }
        },
        "authRequire": true
    },
    "firebaseTokenSet": {
        "name": "json.firebase_token_set",
        "params": {
            "token": {
               "type": "string", 
               "required": true
            }
        },
        "authRequire": true
    },
    "firebaseTokenRemove": {
        "name": "json.firebase_token_remove",
        "params": {
        },
        "authRequire": true
    }
 }